import AssetsConditionRatingDonutChart from "./AssetsConditionRatingDonutChart";
import AssetsRiskLevelDonutChart from "./AssetsRiskLevelDonutChart";
import AssetsStateDonutChart from "./AssetsStateDonutChart";
import AssetsTypeDonutChart from "./AssetsTypeDonutChart";

const ASSETS_STATISTICS_WIDGETS = Object.freeze({
  condition_rating: {
    key: "condition_rating",
    component: <AssetsConditionRatingDonutChart />,
  },
  risk_level: {
    key: "risk_level",
    component: <AssetsRiskLevelDonutChart />,
  },
  state: {
    key: "state",
    component: <AssetsStateDonutChart />,
  },
  type: {
    key: "type",
    component: <AssetsTypeDonutChart />,
  },
});

export {
  ASSETS_STATISTICS_WIDGETS,
  AssetsConditionRatingDonutChart,
  AssetsRiskLevelDonutChart,
  AssetsStateDonutChart,
  AssetsTypeDonutChart,
};
